<template>
    <ValidationObserver rules="required" v-slot="{ handleSubmit }">
        <RightSideBar
            @submit="handleSubmit(editMode ? updatePayscale() : addPayScale())"
            @close="$emit('close')" submit="Save" :loading="loadingData"
            button-class="bg-dynamicBackBtn text-white"
        >
            <template v-slot:title>
                <p class="text-darkPurple">
                {{ editMode ? `Edit Pay Scale` : `New Pay Scale`}}
                </p>
            </template>
            <div>
                <div class="grid grid-cols-12 gap-2 gap-y-4 text-darkPurple" style="margin-top: 1.125rem">
                    <div class="col-span-12">
                        <TextInput placeholder="Enter" 
                            label="Pay Scale ID"
                            :rules="['required']"
                            variant="w-full" v-model="payScaleCredentials.payScaleId" 
                        />
                    </div>
                    <div class="col-span-12">
                        <p class="text-sm">
                            Job Family
                        </p>
                        <ComboBox :isCompensation="true" :options="jobClassificationsOpt" select @addSelectedTags="formattedJobFamilyTags($event)"
                            @removeTag="removedJobFamilyTags($event)" no-custom :exclusive-option-id="'All Job family'"
                        />
                    </div>
                    <div class="col-span-12">
                        <c-select placeholder="--Select--" :options="levelsArray" 
                            label="Job Level ID" 
                            variant="w-full"
                            :rules="['required']"
                            v-model="payScaleCredentials.levelIds" 
                        />
                    </div>
                    <div class="col-span-12">
                        <p class="text-sm">
                            Role
                        </p>
                        <ComboBox :isCompensation="true" :options="allOrgDesignations" select @addSelectedTags="formattedDesignationTags($event)"
                            @removeTag="removedDesignationTags($event)" no-custom
                        />
                    </div>
                    <div class="col-span-12">
                        <p class="text-sm">
                            Job Grade
                        </p>
                        <ComboBox :isCompensation="true" :options="jobGrades" select @addSelectedTags="formattedJobTags($event)"
                        @removeTag="removedJobTags($event)" no-custom :exclusive-option-id="'All Job Grades'"/>
                    </div>
                    <div class="col-span-12">
                        <TextInput placeholder="Enter" 
                            label="Pay Scale" type="number"
                            :rules="['required']"
                            variant="w-full" v-model="payScaleCredentials.payScaleAmount" 
                        />
                    </div>
                </div>
            </div>
        </RightSideBar>
    </ValidationObserver>
</template>

<script>
import * as _ from "lodash"
import VSelect from "vue-select"
import { ValidationObserver } from "vee-validate";
import "vue-select/dist/vue-select.css";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import TextInput from "@scelloo/cloudenly-ui/src/components/text";
import RightSideBar from "@/components/RightSideBar";
import ComboBox from "@/components/ComboBox";

export default {
  components: {
    CSelect,
    ComboBox,
    VSelect,
    ValidationObserver,
    TextInput,
    RightSideBar,
  },
  props: {
        payScaleCred: {
            type: Object,
            default: () => {}
        },
        editMode: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        payScaleGroupType: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loadingData: true,
            functions: [],
            jobGrades: [],
            allOrgDesignations: [],
            jobClassificationsOpt: [],
            levelsArray: [],
            payScaleCredentials: {
                payScaleId: "",
                payScaleAmount: null,
                levelIds: null,
                jobTitleId: [],
                jobClassificationId: [],
                jobGradeIds: [],
            },
        }
    },
    async mounted() {
        this.payScaleCredentials = this.editMode ? this.payScaleCred : this.payScaleCredentials;
        await this.getLevels();
        await this.getJobClassifications();
        await this.getJobGrades();
        if(this.editMode){
            const jobTitleId = new Set(this.payScaleCredentials.jobTitleId);
            const jobClassificationId = new Set(this.payScaleCredentials.jobClassificationId);
            const jobGradeIds = new Set(this.payScaleCredentials.jobGradeIds);

            this.allOrgDesignations.forEach(item => {
                item.checked = jobTitleId.has(item.id);
            });
            this.jobClassificationsOpt.forEach(item => {
                item.checked = jobClassificationId.has(item.id);
            });
            this.jobGrades.forEach(item => {
                item.checked = jobGradeIds.has(item.id);
            });
        }
        this.loadingData = false;
    },
    watch: {
        'payScaleCredentials.jobClassificationId': 'loadDesignations',
        'payScaleCredentials.levelIds': 'loadDesignations'
    },
    methods:{
        loadDesignations() {
            const { jobClassificationId, levelIds } = this.payScaleCredentials;

            if (!levelIds) {
                this.allOrgDesignations = [];
                return;
            }

            this.getAllDesignations(jobClassificationId, levelIds);
        },
        handleTagSelection(selectedOption, allData, allLabel, key, callback = null) {
            if (selectedOption[0]?.id === allLabel) {
                this.payScaleCredentials[key] = allData
                    .filter(opt => opt.id !== allLabel)
                    .map(opt => opt.id);
            } else {
                this.payScaleCredentials[key] = selectedOption.map(opt => opt.id);
            }
            if (callback) {
                callback();
            }
        },
        formattedDesignationTags(selectedOption) {
            this.handleTagSelection(
                selectedOption,
                this.allOrgDesignations,
                'All Roles',
                'jobTitleId'
            );
        },
        formattedJobFamilyTags(selectedOption) {
            this.handleTagSelection(
                selectedOption,
                this.jobClassificationsOpt,
                'All Job family',
                'jobClassificationId'
            );
        },
        formattedJobTags(selectedOption) {
            this.handleTagSelection(
                selectedOption,
                this.jobGrades,
                'All Job Grades',
                'jobGradeIds'
            );
        },
        handleRemovedTag(removedId, dataList, key, callback = null) {
            // Update checked state
            const option = dataList.find(opt => opt.id === removedId);
            if (option) {
                option.checked = false;
            }
            // Remove from credentials
            this.payScaleCredentials[key] =
                this.payScaleCredentials[key].filter(item => item !== removedId);
            // Optional callback
            if (callback) {
                callback();
            }
        },
        removedDesignationTags(removedId) {
            this.handleRemovedTag(
                removedId,
                this.allOrgDesignations,
                'jobTitleId'
            );
        },
        removedJobFamilyTags(removedId) {
            this.handleRemovedTag(
                removedId,
                this.jobClassificationsOpt,
                'jobClassificationId'
            );
        },
        removedJobTags(removedId) {
            this.handleRemovedTag(
                removedId,
                this.jobGrades,
                'jobGradeIds'
            );
        },
        formatDropdownData(data, allLabel, filterFn = null) {
            let formattedData = data;
            if (filterFn) {
                formattedData = formattedData.filter(filterFn);
            }
            return [
                {
                    name: allLabel,
                    id: allLabel,
                    checked: false,
                    disabled: false
                },
                ...formattedData.map(({ id, name }) => ({
                    id,
                    name,
                    checked: false
                }))
            ];
        },
        async getAllDesignations(jobClassificationId, levelIds) {
            const queryParams = `functionId=&source=employees&jobClassificationId=${jobClassificationId.join(',')}&levelIds=${levelIds}`;
            const result = await this.$_getCompensationDesignations(queryParams);
            const designations = result.data.jobTitles || [];
            this.allOrgDesignations = designations.length > 0
                ? [
                    ...designations
                        .map(({ id, title }) => ({
                            id,
                            name: title,
                            checked: false
                        }))
                ]
                : [];
        },
        async getLevels() {
            try {
                const response = await this.$_getLevels("");
                this.levelsArray = response.data.levels;
            } catch (error) {
                throw new Error(error);
            }
        },
        async getJobClassifications() {
            const result = await this.$_getJobClassifications();
            this.jobClassificationsOpt = result.data.jobClassifications.length > 0 ? this.formatDropdownData(
                result.data.jobClassifications,
                'All Job family'
            ) : []
        },
        async getJobGrades(param = "") {
            const result = await this.$_getJobGrade(param);
            this.jobGrades = result.data.grades.length > 0 ? this.formatDropdownData(
                result.data.grades,
                'All Job Grades'
            ) : [];
        },
        async addPayScale(){
            this.loadingData = true;
            const { payScaleId, payScaleAmount, levelIds, jobTitleId,jobClassificationId, jobGradeIds } = this.payScaleCredentials
            const payload = {
                orgId: this.$orgId,
                groupId: this.groupId,
                jobClassificationId,
                name: this.name,
                payScaleGroupType: this.payScaleGroupType,
                jobTitleId,
                jobGradeIds,
                levelIds: levelIds ? [levelIds] : [],
                applyToAllJobClassification: jobClassificationId.length === this.jobClassificationsOpt.length - 1,
                applyToAllJobGrade: jobGradeIds.length === this.jobGrades.length - 1,
                payScaleId,
                payScaleAmount
            }
            try {
                await this.$_addPayScale(payload);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Pay scale successfully added.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error(error, {duration: 3000})
            }
        },
        async updatePayscale(){
            this.loadingData = true;
            const { groupId, id, name, mode, payScaleId, payScaleAmount,levelIds, jobTitleId,
                    jobClassificationId,  jobGradeIds
                } = this.payScaleCredentials
            const payload = {
                id,
                orgId: this.$orgId,
                groupId,
                jobClassificationId,
                name,
                payScaleGroupType: mode,
                jobTitleId,
                jobGradeIds,
                levelIds: levelIds ? [levelIds] : [],
                applyToAllJobClassification: jobClassificationId.length === this.jobClassificationsOpt.length - 1,
                applyToAllJobGrade: jobGradeIds.length === this.jobGrades.length - 1,
                payScaleId,
                payScaleAmount
            }
            try {
                await this.$_updatePayScale(payload);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Pay scale successfully updated.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error(error, {duration: 3000})
            }
        }
    }
};
</script>

<style lang="scss">
.rightSidebar {
  width: 540px !important;
}

.payInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;

  &_fakeInput {
    background: #f7f7ff;
    border-color: #878e99;
    padding: 10px 15px;
    height: 40px;
  }
}
</style>